import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { BaseComponent } from 'src/app/secondadmin/base.component';
import { ClientService } from 'src/app/services/clients/client.service';
import { MasterService } from 'src/app/services/master/master.service';

@Component({
  selector: 'app-edit-subscription-license',
  templateUrl: './edit-subscription-license.component.html',
  styleUrls: ['./edit-subscription-license.component.css']
})
export class EditSubscriptionLicenseComponent extends BaseComponent implements OnInit {
  customer_id;
  updateLicenseForm: FormGroup;
  getCompanyobj: any = [];
  categoryObj: any = [];
  submitted = false;
  license_id: string;
  selectedCompany: string;
  licenseObj: any;
  constructor(
    private formBuilder: FormBuilder,
    private clientsService: ClientService,
    private masterService: MasterService
  ) { super(); }

  ngOnInit(): void {
    this.customer_id = JSON.parse(sessionStorage.getItem('userData')).admin_customer_id;
    if (this.customer_id == 0) this.getCompany();
    this.updateLicenseForm = this.formBuilder.group({
      selectedCompany: [(this.customer_id == 0) ? '' : this.customer_id, Validators.required],
      license_name: ['', [Validators.required, Validators.maxLength(255)]],
      license_code: ['', [Validators.required, Validators.maxLength(50)]],
      category_id: ['', Validators.required],
      category_order: [''],
      suggest_cost: ['']
    });
    if (localStorage.getItem('edit_subscription_license_id')) {
      this.license_id = localStorage.getItem('edit_subscription_license_id');
      this.selectedCompany = localStorage.getItem('edit_subscription_license_company_id');
      this.loadCategories(this.selectedCompany);
      this.masterService.getLicenseCatalogById(this.selectedCompany, this.license_id).subscribe(response => {
        if (response.status) {
          this.licenseObj = response.data;
          this.dataBinding();
        } else {
          this.toastrService.error(response.message || 'License not found');
        }
      });
    }
  }
  getCompany() {
    const self = this;
    this.clientsService.getBUCompanies().subscribe(data => {
      self.getCompanyobj = data.data;
      self.hydrateWorkingCompany(self);
    }, error => {
      console.log(error);
    });
  }
  loadCategories(companyId) {
    if (!companyId) {
      this.categoryObj = [];
      return;
    }
    this.masterService.getLicenseCategoryList(companyId, 1000, 0, '', 'category_id', 'asc').subscribe(data => {
      if (data.status && data.data && data.data.rows) {
        this.categoryObj = data.data.rows;
      } else {
        this.categoryObj = [];
      }
    }, error => {
      console.log(error);
      this.categoryObj = [];
    });
  }
  get f() { return this.updateLicenseForm.controls; }
  dataBinding() {
    this.updateLicenseForm.patchValue({
      selectedCompany: this.selectedCompany,
      license_name: this.licenseObj && this.licenseObj.license_name,
      license_code: this.licenseObj && this.licenseObj.license_code,
      category_id: this.licenseObj && this.licenseObj.category_id ? String(this.licenseObj.category_id) : '',
      category_order: this.licenseObj && this.licenseObj.category_order,
      suggest_cost: this.licenseObj && this.licenseObj.suggest_cost
    });
  }
  updateLicense() {
    this.submitted = true;
    if (this.updateLicenseForm.invalid) {
      return;
    }
    const { selectedCompany } = this.updateLicenseForm.value;
    this.ngxSpinnerService.show();
    this.masterService.updateLicenseCatalog(selectedCompany, this.license_id, this.updateLicenseForm.value).subscribe(data => {
      this.ngxSpinnerService.hide();
      if (data.status) {
        this.toastrService.success('License updated successfully');
        this.router.navigateByUrl('/corporate/subscription-license-list');
      } else {
        this.toastrService.error(data.message);
      }
    }, error => {
      this.ngxSpinnerService.hide();
      this.toastrService.error(error.message);
    });
  }
}
